import { ReactElement } from "react";
import { BsSearch } from "react-icons/bs";
import { Loader2 } from "lucide-react";
import { Input } from "./ui/Input";
import { cn } from "../lib/utils";

type Props = {
  onSearchChange: (search: string) => void;
  placeholder?: string;
  className?: string;
  value: string;
  isSearching?: boolean;
};

const Search = ({
  onSearchChange,
  placeholder,
  className,
  value,
  isSearching = false,
}: Props): ReactElement => {
  return (
    <div className="relative">
      <Input
        className={cn(
          "h-[35px] w-full pl-10 max-w-[312px] rounded-xl ",
          className
        )}
        placeholder={placeholder ? placeholder : "Search"}
        onChange={e => onSearchChange(e.target.value)}
        value={value}
      />
      {isSearching ? (
        <Loader2 className="absolute top-[10px] left-3 w-4 h-4 text-orange-500 animate-spin" />
      ) : (
        <BsSearch
          height={12}
          width={12}
          color="#868686"
          className="absolute top-[10px] left-3"
        />
      )}
    </div>
  );
};

export default Search;
